<div class="row">
  <div class="col-md-6 ">
    <div class="card card-body">
      <form class="form-horizontal" #NauticalMile="ngForm">
        <div class="form-group row">
          <label for="Port1"
          class="col-form-label col-md-4 ">Port 1</label>
          <div class="col-md-8">
            <select class="form-control"
              name="Port1"
              id="Port1"
              tabindex="1"
              [(ngModel)]="port1"
              required>
              @for (por of ports; track $index) {
                <option [ngValue]="por.name">
                  {{por.nameTranslations['en']}}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="Port2"
          class="control-label col-md-4 ">Port 2</label>
          <div class="col-md-8">
            <select class="form-control"
              name="Port2"
              id="Port2"
              tabindex="2"
              [(ngModel)]="port2"
              required>
              @for (por2 of ports; track $index) {
                <option value="{{por2.name}}">
                  {{por2.nameTranslations['en']}}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="distance" class="control-label col-md-4 ">Distance</label>
          <div class="col-md-8">
            <input type="text"
              class="form-control"
              name="distance"
              id="distance"
              tabindex="3"
              [(ngModel)]="distance">
            </div>
          </div>
          <div>
            <div class="col-md-4 "></div>
            <button type="submit"
              class="btn btn-primary"
              (click)="add()"
              [disabled]="!NauticalMile.form.valid"
              tabindex="4">Save
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-6">
      <div class="col-md-12 col-xs-12 vh-100">
        <ag-grid-angular
          class="ag-theme-alpine"
          [gridOptions]="gridOptions"
          (gridReady)="gridSetting($event)"
          [columnDefs]="columnDefs"
          [rowData]="importedData"
          [domLayout]="'autoHeight'"
          [pagination]= "true"
          [paginationPageSize]="10"
          [paginationPageSizeSelector]="[10,20,30]"
          [enableCellTextSelection]="true"
          >
        </ag-grid-angular>
      </div>
    </div>
  </div>
